import {Color} from 'components/design-guide/Action/Button/styles/colors';
import {ButtonStateStyles} from 'components/design-guide/Action/Button/styles/types';
import {ButtonState} from 'components/design-guide/Action/Button/types';

export const DESTRUCTIVE_STYLES = new Map<ButtonState, ButtonStateStyles>([
  [
    'default',
    {
      fill: Color.DESTRUCTIVE_DEFAULT,
      text: Color.DESTRUCTIVE_DEFAULT_BORDER_AND_TEXT,
      border: Color.DESTRUCTIVE_DEFAULT_BORDER_AND_TEXT,
      boxShadow: `0 1px 1px ${Color.ZERO_05_BLACK_SHADOW}`
    }
  ],
  [
    'hover',
    {
      fill: Color.DESTRUCTIVE_HOVER,
      text: Color.DESTRUCTIVE_HOVER_BORDER_AND_TEXT,
      border: Color.DESTRUCTIVE_HOVER_BORDER_AND_TEXT,
      boxShadow: `0 1px 1px ${Color.ZERO_05_BLACK_SHADOW}`
    }
  ],
  [
    'active',
    {
      fill: Color.DESTRUCTIVE_ACTIVE,
      text: Color.DESTRUCTIVE_ACTIVE_BORDER_AND_TEXT,
      border: Color.DESTRUCTIVE_ACTIVE_BORDER_AND_TEXT
    }
  ],
  ['disabled', {fill: Color.DISABLED, text: Color.DISABLED_TEXT, border: Color.DISABLED_BORDER}],
  [
    'focus',
    {
      fill: Color.DESTRUCTIVE_DEFAULT,
      text: Color.DESTRUCTIVE_DEFAULT_BORDER_AND_TEXT,
      border: Color.DESTRUCTIVE_DEFAULT_BORDER_AND_TEXT,
      boxShadow: `0 0 1px 2px ${Color.DESTRUCTIVE_SHADOW}`
    }
  ],
  [
    'processing',
    {
      fill: Color.DESTRUCTIVE_ACTIVE,
      text: Color.DESTRUCTIVE_ACTIVE_BORDER_AND_TEXT,
      border: Color.DESTRUCTIVE_ACTIVE_BORDER_AND_TEXT,
      boxShadow: `0 1px 1px ${Color.ZERO_05_BLACK_SHADOW}`
    }
  ]
]);
